export function singletonFromFactory(ServiceFactory) {
    let instance;
    const getInstance = () => {
        if (!instance) {
            throw new Error(`Service has not been instantiated`);
        }
        return instance;
    };
    getInstance.wrapped = ServiceFactory;
    getInstance.createInstance = (...args) => (instance = ServiceFactory(...args));
    getInstance.clearInstance = () => (instance = null);
    getInstance.hasInstance = () => Boolean(instance);
    return getInstance;
}
export function singleton(Service) {
    const result = singletonFromFactory((...args) => new Service(...args));
    result.wrapped = Service;
    return result;
}
//# sourceMappingURL=singleton.js.map